












import _ from 'lodash'
import { Component } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { ELevel } from '@/services/Menus'
import { UserProfile } from '@/store/modules/views/userProfile/states'
import { IJob } from '@/store/modules/views/job/states'
import { ITimeline } from '@/store/modules/views/schedule/states'

@Component
export default class Log extends VueExtendedBaseComponent {
  private header = 'ประวัติการปฏิบัติงาน'

  @Getter('schedule/logJobLists')
  private logJobLists: ITimeline & IJob

  @Getter('userprofile/getProfile')
  private profile!: UserProfile

  @Action('components/updateTitlePage')
  private updateTitlePage!: (title: string) => void

  @Action('schedule/getScheduleJobLogList')
  private getScheduleJobLogList!: (options: {}) => void

  private async created() {
    this.updateTitlePage(this.header)
    if (this.profile.role.name !== 'ผู้ดูแลระบบ') {
      this.$store.dispatch('components/setLevel', {id: this.profile._id, mode: ELevel.USER})
      // this.$router.push(`/action/profile`)
    }
    await this.getScheduleJobLogList({
      id: this.$route.params.status,
    })
  }
}
